import Vue from 'vue'

// Currency filter that format numbers.
Vue.filter('currency', (value, minFraction = 3) => {
  if (typeof value !== 'number') {
    return value
  }

  let oldValue = value.toFixed(minFraction)
  return oldValue.replace(/(\d)(?=(\d{3})+(?!\d)[.])/g, '$1,').replace(/\.?0+$/, '')
})

// Percentage filter that display a percentage sign beside the number.
Vue.filter('percentage', value => {
  if (typeof value !== 'number') {
    return value
  }

  return value + ' %'
})

// Date filter that format date and it used moment filter.
Vue.filter('date', (value, format = 'DD/MM/YYYY') => {
  if (!value) {
    return value
  }

  return Vue.moment(value).format(format)
})

// Date and Time filter that format date and time and it used date filter.
Vue.filter('dateTime', value => {
  return Vue.options.filters.date(value, 'DD/MM/YYYY hh:mm A')
})

Vue.filter('capitalize', value => {
  return value
    .split('_')
    .flatMap(element => element.charAt(0).toUpperCase() + element.slice(1).toLowerCase() + ' ')
    .join(' ')
})

// Truncate a string in the middle of it
Vue.filter('truncate', (fullStr, strLen = 30, separator = '...') => {
  if (fullStr.length <= strLen) return fullStr

  const sepLen = separator.length
  const charsToShow = strLen - sepLen
  const frontChars = Math.ceil(charsToShow / 2)
  const backChars = Math.floor(charsToShow / 2)

  return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars)
})
